import escrow from "./service/servicesSlicer";

const rootReducer = {
  escrow,
};

export default rootReducer;
